import React from "react";
import { useMediaQuery } from "react-responsive";
import "./exploreWork.css";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const ExploreWork = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="explore-work">
      {isMobile ? (
        <div className="mobile-version">
          <div className="explore-work-container ">
            <div className="explore-work-left">
              <h1>
                <span className="title-word">Empowering</span> Startups & Small
                Businesses Across the USA
              </h1>
              <div className="image-box">
                <LazyLoadImage
                  src={require("../../assets/explore-work-section.jpg")}
                  alt="Explore Picture"
                  effect="blur"
                />
              </div>
            </div>
            <div className="explore-work-right">
              <div className="text-wrapper">
                <p>
                  At CS Lab, we help startups and small businesses amplify their
                  voice and connect with their audience. Through creative and
                  strategic marketing, we turn challenges into opportunities,
                  driving growth and making your brand stand out in the
                  competitive USA market.
                </p>
                <Link to="/services" onClick={handleClick}>
                  <button className="btn">Explore Our Work</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="explore-work-container">
            <div className="explore-work-left">
              <div className="image-box">
                <LazyLoadImage
                  src={require("../../assets/explore-work-section.jpg")}
                  alt="Explore Picture"
                  effect="blur"
                />
              </div>
            </div>
            <div className="explore-work-right">
              <div className="text-wrapper">
                <h1>
                  <span className="title-word">Empowering</span> Startups &
                  Small Businesses Across the USA
                </h1>
                <p>
                  At CS Lab, we help startups and small businesses amplify their
                  voice and connect with their audience. Through creative and
                  strategic marketing, we turn challenges into opportunities,
                  driving growth and making your brand stand out in the
                  competitive USA market.
                </p>
                <Link to="/services" onClick={handleClick}>
                  <button className="btn">Explore Our Work</button>
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default ExploreWork;
